import { Model } from '@/models/Model';
export class SkillCategory extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'SkillCategory';
        this.$endpoint = '/skill-categories';
        this.$fillable = [];
    }
}
export var SkillCategoryIncludes;
(function (SkillCategoryIncludes) {
    SkillCategoryIncludes["SKILLS"] = "skills";
})(SkillCategoryIncludes || (SkillCategoryIncludes = {}));
